export enum FavoritesAction {
  Add = 'FAVORITES_ADD',
  Remove = 'FAVORITES_REMOVE',
}
